import cookie from 'universal-cookie';

export default new cookie();
